import type { Showcase } from '@k4ia/shared'
import { Avatar } from './Avatar'

/**
 * Der Bildschirm nach dem Scannen eines Showcase-Tags (SPEC „NFC-Konzept").
 * Der Besucher steht vor dem Stand und hat gerade den Tag angetippt — er
 * will nicht die allgemeine K4ia-Oberfläche, sondern diesen einen Showcase.
 * Eine Frage, zwei Antworten: vorlesen oder lesen. Danach erklärt K4ia sofort.
 *
 * „Vorlesen" braucht das Mikrofon, weil der Sprachmodus ein Gespräch ist —
 * K4ia liest vor, und der Besucher kann zurückfragen. Ist es nicht
 * freigegeben, sagt der Knopf das und gibt es mit dem Tippen frei; die
 * Browser-Nachfrage kommt danach ohnehin.
 */
export function ShowcaseEntryScreen({
  showcase,
  micGranted,
  vorlesen = true,
  onChoose,
}: {
  showcase: Pick<Showcase, 'title' | 'shortText'>
  micGranted: boolean
  /** „Vorlesen“ zeigen? Im Admin abschaltbar (Konfiguration → Gespräch). */
  vorlesen?: boolean
  onChoose: (mode: 'voice' | 'chat') => void
}) {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-8 px-6 py-14 text-center">
      <Avatar state="idle" size={96} showLabel={false} />
      <div className="max-w-md space-y-3">
        <p className="font-mono text-xs uppercase tracking-wider text-text-muted">Du stehst vor</p>
        <h1 className="text-4xl sm:text-5xl">{showcase.title}</h1>
        {showcase.shortText && (
          <p className="leading-relaxed text-text-muted">{showcase.shortText}</p>
        )}
      </div>

      <div className="w-full max-w-md space-y-3">
        {vorlesen && <p className="text-sm text-text-muted">Wie soll ich dir davon erzählen?</p>}
        {vorlesen && (
          <button
            type="button"
            onClick={() => onChoose('voice')}
            className="w-full rounded-full bg-accent px-6 py-4 text-lg font-semibold text-on-accent shadow-float transition"
          >
            Vorlesen
            <span className="block text-xs font-normal opacity-80">
              {micGranted
                ? 'K4ia spricht — du kannst zurückfragen.'
                : 'Gibt das Mikrofon frei, damit du zurückfragen kannst.'}
            </span>
          </button>
        )}
        <button
          type="button"
          onClick={() => onChoose('chat')}
          className="w-full rounded-full bg-surface-2 px-6 py-4 text-lg font-semibold text-text transition"
        >
          Im Chat lesen
        </button>
      </div>
    </div>
  )
}
